// production start
export const BASE_URL = "https://frontapi.mchemist.com/api/v1";
export const Image_URL = "https://frontapi.mchemist.com/uploads";
export const CLIENT_ID = "b150e0b836bf6a04e1546671690f2899";
export const SECRET_KEY =
  "605bcc5691ae77a84e635ffa63903587d9583fd1188f6e803f1bec3a1c664d4c";

// production end

// stagin start
// export const BASE_URL = "https://frontapi.mchemist.in/api";
// export const Image_URL = "https://frontapi.mchemist.in/uploads";
// export const CLIENT_ID = "02b3ccfffb3e1d31ca6fee0404329968";
// export const SECRET_KEY =
//   "0b1add6f365f3eba18cdbf7aa386a599fd7add3e8495528d42b2a15aa6e69200";

// stagin end

// for localhost start
// export const BASE_URL ='https://frontapi.mchemist.in/api';
// export const BASE_URL ='https://frontapi.mchemist.in/api/v1';
// export const Image_URL ='https://frontapi.mchemist.in/uploads'; 
// export const CLIENT_ID = '2134824a7f6ecf395c935cce37999530';
// export const SECRET_KEY = 'c45d114d26ac9d86eee4fdef76095c474f6b4b635849a64c88271c4342cd372d';

// for localhost end
